<template>
    <nav class="CategorySort">
        <div class="CategorySort-label">
            <img src="/frontend/images/product/list/icon-category-sort.svg" alt="sort">
            <div class="CategorySort-labelText">{{ categorySortLabel }}:</div>
        </div>
        <div class="CategorySort-links" v-if="sort">
            <button v-for="sortBtn in sort.available"
                    :class="{ 'CategorySort-link': true, 'is-active': sortBtn.value === sort.selected }"
                    :key="sortBtn.value" @click="sortProduct(sortBtn.value)"
                    type="button">{{ sortBtn.label }}
            </button>
        </div>
        <div class="CategorySort-label">
            {{ productCount }} {{ productTotalLabel }}
        </div>
    </nav>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapActions, mapGetters} from "vuex";

export default defineComponent({
    name: "CategorySort",
    computed: mapGetters({
        sort: 'getSort',
        productCount: 'getResultsCount',
        productTotalLabel: 'getResultsTotalLabel',
        categorySortLabel: 'getCategorySortLabel',
    }),
    methods: mapActions({
        sortProduct: 'SORT_PRODUCTS'
    })
});
</script>
